<template>
    <div><!-- 部材品質異常聯絡單 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>部材品質異常聯絡單</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'element_FactoryTypeOpt'" v-model="unElQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div>
                                </div>                                
                            </div>
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('QualityInfo_Vue.CustomerName')}}：</p>                                    
                                    <input style="width: 300px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="unElQueryParam.customerName">                                                        
                                    <Select2 style="width: 500px;" v-if="!disableCusName_input" v-model="unElQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true }" />
                                </div>
                            </div>
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{ i18n("Element.TrialMassProduction") }}：</p>     
                                    <div
                                        v-for="(item, key) in trialMassSearchProductionList"
                                        :key="'coa_RowStatusOpt' + key"
                                    >
                                        <input
                                        type="radio"
                                        name="dataStatus_input"
                                        v-model="unElQueryParam.dDown_Trial"
                                        :value="item.trialMassProductionId"
                                        />{{ item.trialMassProductionCaption }}
                                    </div>                               
                                </div>
                            </div>
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('QualityInfo_Vue.PartNumber')}}：</p>
                                    <input type="text" maxlength="50" v-model="unElQueryParam.partNumber">
                                </div>
                            </div>                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QualityInfo_Vue.Status')}}：</p>
                                    <div v-for="(item, key) in carStatusList" :key="'ueRowStatus_input_' + key">
                                       <input type="radio" :name="'ue_RowStatusOpt'" v-model="unElQueryParam.rowStatus" :value="item.carStatusId" >{{item.carStatusCaption}}
                                    </div> 
                                </div>
                            </div>
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{ i18n("Element.OccuranceType") }}：</p>                                    
                                    <select style="width:200px;height:30px;" v-model="unElQueryParam.happenType" >
                                        <option v-for="option in carHappenTypeList" :key="option.happenTypeId" :value="option.happenTypeId">{{option.happenTypeCaption}}</option>
                                    </select>
                                </div>
                            </div>                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{ i18n("Element.OccuranceDates") }}：</p>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="unElQueryParam.createDateBegin"></date-picker> 
                                    <span>~</span>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="unElQueryParam.createDateEnd"></date-picker>
                                </div>
                            </div>
                            <div class="btn_group">                               
                                <button type="button" class="btn btn-edit mr-2" @click="unElQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="unElExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                                <router-link class="btn btn-primary" v-if="!isMember" to="" @click.native="unElAddNewEvent">{{$t('Buttons.AddNew')}}</router-link>                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {            
            factoryList: this.$t('factoryQMList'), //廠別 清單
            carStatusList: this.$t('carStatusList'), //狀態 清單
            carHappenTypeList: this.$t('carHappenTypeList'), //發生類別 清單
            trialMassSearchProductionList: this.$t('trialMassSearchProductionList'), //試作量產 清單
            unElQueryParam: {
                hadQuery : false,
                customerName : '',
                createDateBegin :null,
                createDateEnd :null,
                happenType : -1,
                dDown_Trial : '',
                partNumber : '',
                rowStatus : '',
                factoryId : ''
            }
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
            this.carStatusList = this.$t('carStatusList') //狀態 清單
            this.carHappenTypeList = this.$t('carHappenTypeList') //發生類別 清單
            this.trialMassSearchProductionList = this.$t('trialMassSearchProductionList') //試作量產 清單
        }
    },
    methods: {
        unElQueryEvent (){           
            this.unElQueryParam.hadQuery = true; 
            this.$emit('unElQueryEvent',this.unElQueryParam);
        },              
        unElExportEvent (){//匯出            
            this.$emit('unElExportEvent',this.unElQueryParam);
        },        
        unElAddNewEvent (){
            sessionStorage.setItem('carGuid', 'new');
            this.$router.push('elementinformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
        this.getCacheQueryParam('UnEl_QueryParam' , this.unElQueryParam);        
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.unElQueryParam.factoryId = userFactoryId;
        }          
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.unElQueryParam.vendorId = userInfo.vendorId;
            this.unElQueryParam.customerName = userInfo.companyName;
        }else{
            this.initMemberQMList();     
        }        
        if(this.unElQueryParam.hadQuery){
            this.$emit('unElQueryEvent',this.unElQueryParam);           
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .fluid {
        display: flex;
        align-items: center;

        > .search-fluid {
            display: flex;
            align-items: center;
            margin: .5rem 1rem;
            margin-left: 0;
            // width: 500px;

            > p {
                margin-right: 1rem;
                margin-bottom: 0;
            }
            > .purchase_input {
                margin-bottom: 0;
            }
            > input {
                flex: 1;
                margin: 0 .5rem;
            }
            > div {
                margin: 0 .5rem;
            }            
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
